/**
 * filter-node.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Component, Input } from "@angular/core";
import { ServerDataType } from "../common/data/data-types";
import { TypedData } from "../common/data/typed-data";
import {
    ConstantNode,
    FilterNode,
    OperatorNode,
    UndefinedNode,
    VariableNode
} from "./filter-node";
import {
    FilterNodeType,
    INEQUALITIES,
    Operator,
    Operators,
    OperatorSignature
} from "./operators";

@Component({
    selector: "filter-node",
    template: `
<div [class]="'group group' + node.depth + (isFinalOperator() ? ' final' : '')">
<template [ngIf]="node && isOperator(node)">
    <!-- horizontal operator -->
    <table class="operator" *ngIf="isFinalOperator()">
        <!--<tr>
            <td colspan="3">
                {{node.depth}}
            </td>
        </tr>-->
        <tr>
            <td *ngIf="node.operands.length !== 2">
                <div>
                    <label>Expression</label>
                    <button
                        [disabled]="!node.parent"
                        type="button"
                        class="btn btn-xs btn-warning pull-right"
                        (click)="node.revert()">
                        change type
                    </button>
                </div>
                <select
                    [formControl]="node.operatorControl"
                    class="form-control operatorControl">
                    <option disabled [ngValue]="null">
                        -- Select operator --
                    </option>
                    <option
                        *ngFor="let op of node.availableOperators"
                        [value]="op.name"
                        [disabled]="!op.userSelectable">
                        {{op.name}}
                    </option>
                </select>
            </td>
            <td *ngIf="node.operands.length > 0">
                <filter-node [node]="node.operands[0]">
                </filter-node>
            </td>
            <td *ngIf="node.operands.length === 2">
                <div>
                    <label>Expression</label>
                    <button
                        [disabled]="!node.parent"
                        type="button"
                        class="btn btn-xs btn-warning pull-right"
                        (click)="node.revert()">
                        change type
                    </button>
                </div>
                <select
                    [formControl]="node.operatorControl"
                    class="form-control operatorControl">
                    <option disabled [ngValue]="null">
                        -- Select operator --
                    </option>
                    <option
                        *ngFor="let op of node.availableOperators"
                        [value]="op.name"
                        [disabled]="!op.userSelectable">
                        {{op.name}}
                    </option>
                </select>
            </td>
            <td *ngFor="let operand of node.operands | slice:1">
                <filter-node [node]="operand">
                </filter-node>
            </td>
    </table>
    <table class="operator" *ngIf="!isFinalOperator()">
        <!--<tr>
            <td rowspan="3">
                {{node.depth}}
            </td>
        </tr>-->
        <tr *ngIf="node.operands.length !== 2">
            <td>
                <div>
                    <label>Expression</label>
                    <button
                        [disabled]="!node.parent"
                        type="button"
                        class="btn btn-xs btn-warning pull-right"
                        (click)="node.revert()">
                        change type
                    </button>
                </div>
                <select
                    [formControl]="node.operatorControl"
                    class="form-control operatorControl">
                    <option disabled [ngValue]="null">
                        -- Select operator --
                    </option>
                    <option
                        *ngFor="let op of node.availableOperators"
                        [value]="op.name"
                        [disabled]="!op.userSelectable">
                        {{op.name}}
                    </option>
                </select>
            </td>
        </tr>
        <tr>
            <td *ngIf="node.operands.length > 0">
                <filter-node [node]="node.operands[0]">
                </filter-node>
            </td>
        </tr>
        <tr *ngIf="node.operands.length === 2">
            <td>
                <div>
                    <label>Expression</label>
                    <button
                        [disabled]="!node.parent"
                        type="button"
                        class="btn btn-xs btn-warning pull-right"
                        (click)="node.revert()">
                        change type
                    </button>
                </div>
                <select
                    [formControl]="node.operatorControl"
                    class="form-control operatorControl">
                    <option disabled [ngValue]="null">
                        -- Select operator --
                    </option>
                    <option
                        *ngFor="let op of node.availableOperators"
                        [value]="op.name"
                        [disabled]="!op.userSelectable">
                        {{op.name}}
                    </option>
                </select>
            </td>
        </tr>
        <tr *ngFor="let operand of node.operands | slice:1">
            <td>
                <filter-node [node]="operand">
                </filter-node>
            </td>
        </tr>
    </table>
</template>

<div *ngIf="node?.nodeType === 'variable'" class="state-variable">
    <div>
        <label>Variable</label>
        <button
            type="button"
            class="btn btn-xs btn-warning pull-right"
            (click)="node.revert()">
            change type
        </button>
    </div>
    <select
        [formControl]="node.variableControl"
        class="form-control">
        <option disabled [ngValue]="null">-- Select variable --</option>
        <option *ngFor="let sv of node.filteredVariables" [value]="sv.name">
            {{sv.displayName || sv.name}}
        </option>
    </select>
</div>

<table *ngIf="node?.nodeType === 'value'" class="constant">
    <tr>
        <td colspan="2">
            <label>Value</label>
            <button
                type="button"
                class="btn btn-xs btn-warning pull-right"
                (click)="node.revert()"
                [disabled]="node.parent?._childValueRestrictions">
                change type
            </button>
        </td>
    </tr>
    <tr>
        <td>
            <div class="form-group">
                <select
                    class="form-control constTypeSelector"
                    [formControl]="node.typeControl">
                    <option [ngValue]="null">
                        -- Select a type --
                    </option>
                    <option
                        *ngFor="let type of node.allowedTypes"
                        [value]="type">
                        {{type}}
                    </option>
                </select>
            </div>
        </td>
        <td *ngIf="node.type">
            <typed-control
                [input]="node"
                [control]="node.valueControl"
                [iconTray]="false"
                [clearButton]="false"
                [validationTray]="false">
            </typed-control>
        </td>
    </tr>
</table>

<div *ngIf="node !== null && node.nodeType === null" class="undefined">
    <div>
        <label class="text-danger">New node</label>
        <button
            type="button"
            class="btn btn-xs btn-warning pull-right"
            disabled>
            change type
        </button>
    </div>
    <select class="form-control" [formControl]="node.typeControl">
        <option [ngValue]="null" disabled>-- select new node type --</option>
        <option>variable</option>
        <option>value</option>
        <option>expression</option>
    </select>
</div>

<div *ngIf="!node">
	<em class="text-danger">No filter node found.</em>
</div>
</div>
    `,
    styles: [`
        table {
            width: 100%;
        }
        table td {
            /* border: 1px solid #ccc; */
            padding: 2px 5px;
        }
        .constant {
            margin-top: 13px;
        }
        table.constant td {
            padding: 0px;
        }
        .group1 {
            border-left: 2px solid black;
        }
        .final {
            border-right: 2px solid black;
        }
        .group2 {
            border-left: 2px solid blue;
        }
        .group3 {
            border-left: 2px solid green;
        }
        .group {
            border-radius: 5px;
            padding-left: 5px;
        }
        .operatorControl {
            font-style: italic;
            color: var(--color-green)
        }
        .revert {
            width: 100%;
        }
    `]
})
export class FilterNodeComponent
{
    @Input()
    public root : boolean;

    @Input()
    public node : FilterNode;

    @Input()
    public returns : ServerDataType;

    @Input()
    public variables : TypedData[];

    public isOperator (node : FilterNode) : node is OperatorNode
    {
        return node.nodeType === "expression";
    }

    public opNames () : string[]
    {
        return (this.node as OperatorNode).availableOperators.map(
            (op : Operator) => op.name);
    }

    public signatures () : OperatorSignature[]
    {
        if (!this.isOperator(this.node))
        {
            throw new Error("Cannot compute signatures for non-op nodes");
        }
        if (this.node.operator.isBinary())
        {
            return this.node.operator.signature.filter(
                (sig : OperatorSignature) => {
                    if ((this.node as OperatorNode).operands[0])
                    {
                        //
                    }
                });
        }
        else
        {
            throw new Error("UNIMPLEMENTED CASE");
        }
    }

    public isFinalOperator () : boolean
    {
        if (!this.isOperator(this.node))
        {
            return false;
        }
        return this.node.operands.every(
            (node : FilterNode) => !(node instanceof OperatorNode));
    }

    public af<T> (ob : Set<T>) : T[]
    {
        if (!ob)
        {
            return null;
        }
        else
        {
            return Array.from(ob);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/aggregation/filter-node.component.ts